import {backendURL} from "../../../resources/values";
const fetchDesignDetails = async (projectId) => {
    try {
        const response = await fetch(`${backendURL}/projects/design/${projectId}/`);
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('Server responded with an error!');
        }
    } catch (error) {
        console.error("Failed to fetch projects:", error);
        return null;
    }
};

const fetchProjects = async () => {
    try {
        const url = `${backendURL}/projects/`;
        console.log("URL : " , url);
        const response = await fetch(`${backendURL}/projects/`);
        if (response.ok) {
            const data = await response.json();
            console.log(data);
            return data;
        } else {
            throw new Error('Server responded with an error!');
        }
    } catch (error) {
        console.error("Failed to fetch projects:", error);
        return null;
    }
};

const fetchProjectDetails = async (projectId) => {
    try {
        const url = (`${backendURL}/projects/${projectId}/`);
        const response = await fetch(url);
        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error('Server responded with an error!');
        }
    } catch (error) {
        console.error("Failed to fetch projects:", error);
        return null;
    }
};

const updateProjectStatus = async (projectId, status) => {

    const url = `${backendURL}/projects/status/${projectId}/`;
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({status: status})
        });

        if (response.ok) {
            const jsonResponse = await response.json();
            console.log('Data posted successfully:', jsonResponse);
            // alert('Design data submitted successfully');
            return true;
        } else {
            console.error('Failed to post data:', response.statusText);
            // alert('Failed to post data:'+ response.statusText);
            return false;
        }
    } catch (error) {
        console.error('Error:', error);
        return false;
    }

}

export {fetchDesignDetails, fetchProjects, fetchProjectDetails, updateProjectStatus}